import { ConfigActionType } from '../action-types/configTypes';
import { ConfigActions } from '../actions/configTypes';


const initialState: ConfigFile = <ConfigFile>{ properties: {}, labels: {}, components: {} };

const configReducer = (state: ConfigFile = initialState, action: ConfigActions) => {
  switch (action.type) {
    case ConfigActionType.SET_CONFIG_FILE:
      return action.payload;
    default:
      return state;
  }
};

export default configReducer;
